// extracted by mini-css-extract-plugin
export var card = "Card-module--card---ehP1";
export var cardContent = "Card-module--card-content--6lY5J";
export var root = "Card-module--root--Y4xTv";